
import React, { createContext, useState, useEffect } from "react";
import SR from "../../public/assets/images/sr.svg";

export const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [selectedCurrency, setSelectedCurrency] = useState("SAR");
  const [value, setValue] = useState(1); // Default value
  const [loading, setLoading] = useState(true);

  const currencyRates = {
    SAR: 1,
    USD: 0.27,
    Euro: 0.25,
    Pound: 0.21,
  };

  const currencyImages = {
    SAR: SR,
  };

  const allowedCountries = ["SA", "OM", "KW", "QA", "AE"]; // ISO codes

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();
        const countryCode = data?.country_code;

        if (allowedCountries.includes(countryCode)) {
          setSelectedCurrency("SAR");
          setValue(currencyRates["SAR"]);
        } else {
          setSelectedCurrency("USD");
          setValue(currencyRates["USD"]);
        }
      } catch (error) {
        // fallback to USD if error
        setSelectedCurrency("USD");
        setValue(currencyRates["USD"]);
        console.error("Failed to detect location, defaulting to USD", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCountry();
  }, []);

  const changeCurrency = (currency) => {
    setSelectedCurrency(currency);
    setValue(currencyRates[currency]);
  };

  return (
    <CurrencyContext.Provider
      value={{
        selectedCurrency,
        value,
        changeCurrency,
        currencyImages,
        loading,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};
